import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {IntroConfig} from "./IntroConfig";
import {Sound} from "../sound/Sound";
import {Game} from "../Game";

export class PreIntro extends PIXI.Container implements StageLayer {
    private _button: ContinueButton;
    private _disclaimerText?: PIXI.Text;
    private _completed: boolean;
    private _startIntroCallback: (value: any) => void;
    private _tl: gsap.core.Timeline;

    constructor() {
        super();

        this._completed = false;
        this._tl = new gsap.core.Timeline({
            paused: true,
        });
        const disclaimerTime: number = 6;
        const text1: string = "THIS GAME CONTAINS DISTURBING IMAGES AND INTENSE GRAPHIC CONTENT, INCLUDING VIOLENCE, BLOOD, AND UNSETTLING VISUALS";
        const text2: string = "SOME SCENES MAY BE DISTRESSING FOR SENSITIVE PLAYERS.";
        const text3: string = "DISCRETION IS ADVISED BEFORE CONTINUING";
        const disclaimerText: PIXI.Text = new PIXI.Text(Game.apiPlugin.translations.translate(text1) + ".\n" + Game.apiPlugin.translations.translate(text2) + "\n" + Game.apiPlugin.translations.translate(text3), {
            fill: 0xFFFFFF,
            fontWeight: "bold",
            fontSize: 26,
            wordWrap: true,
            wordWrapWidth: 700,
            breakWords: true,
            align: "center"
        });
        const bg: PIXI.Graphics = new PIXI.Graphics().beginFill(0x000000, 1).drawRect(-480, -480, 1680, 1680).endFill();
        bg.interactive = true;
        bg.once('pointerdown', () => {
            this._tl.seek(disclaimerTime);
        });
        this.addChild(bg, disclaimerText);
        disclaimerText.anchor.set(0.5);
        disclaimerText.position.set(360);
        this._disclaimerText = disclaimerText;
        this._tl.add([
            () => {
                if (this._disclaimerText) {
                    this._disclaimerText.alpha = 0;
                    this._disclaimerText.visible = false;
                    this._disclaimerText.destroy();
                    delete this._disclaimerText;
                }
                bg.interactive = false;
            },
        ], disclaimerTime);


        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(IntroConfig._assetLoader.getSpineAsset("gameIntro"));
        spine.state.setAnimation(0, "animation", true);
        spine.position.set(360);

        this._button = new ContinueButton();
        this._button.enable(true);
        this._button.pivot.set(this._button.width * 0.5, this._button.height * 0.5);
        this._button.addClickCallback(() => {
            Game.soundPlayer.playSound(Sound.CONTINUE_BUTTON);
            this.startIntro();
        });

        this.onResize();
        this._tl.add(() => {
            this._button.alpha = 0;
            this.addChild(spine, this._button);
        });

        // 2 second hold before it starts looping itself
        this._tl.to(this._button, {alpha: 1, duration: 0.2}, disclaimerTime + 0.2);
    }

    public onResize(): void {
        if (NolimitApplication.isLandscape) {
            this._button.position.set(360, 615);
            if (this._disclaimerText?.visible) {
                this._disclaimerText.style.wordWrapWidth = 910;
            }
        } else {
            if (this._disclaimerText?.visible) {
                this._disclaimerText.style.wordWrapWidth = 700;
            }

            const centerBottom: number = (NolimitApplication.screenBounds.bottom - 640) * 0.5 + 640;
            this._button.position.set(360, centerBottom);
        }
    }

    public show(): void {
        NolimitApplication.addLayer("PRE_INTRO", this);
    }

    public complete(): Promise<any> {
        if (this._completed) {
            return Promise.resolve();
        }

        this._tl.play();

        return new Promise((resolve) => {
            this._startIntroCallback = resolve;
        });
    }

    private startIntro(): void {
        this._button.enable(false);
        this._completed = true;
        if (this._startIntroCallback) {
            this._startIntroCallback(undefined);
        }
        const tl: gsap.core.Timeline = gsap.timeline({
            delay: 0.1
        });
        tl.to(this, {duration: 0.2, alpha: 0});
        tl.add(() => {
            NolimitApplication.removeLayer("PRE_INTRO");
            this._tl.pause();
            this._tl.kill();
        });
    }

}